import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.683 2.983a.7.7 0 0 0-.7.7v12.634a.7.7 0 0 0 .7.7H9a.7.7 0 1 0 0-1.4H4.383V7.542h11.234V9a.7.7 0 1 0 1.4 0V3.683a.7.7 0 0 0-.7-.7zm11.934 3.159H4.383V4.383h11.234z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.197 13.957a.761.761 0 1 0 0-1.522.761.761 0 0 0 0 1.522"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.859 12.788a1.691 1.691 0 1 0-3.267.875 1.691 1.691 0 0 0 3.267-.875m-2.434-2.549a3.091 3.091 0 0 1 3.424 4.62l1.568 1.568a.7.7 0 0 1-.99.99L14.86 15.85a3.091 3.091 0 1 1-2.435-5.61",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=GoToDateIcon20.js.map